(function () {
  const form = document.getElementById('pk-product-form');
  if (!form) return;

  const priceEl = document.getElementById('pk-price-value');
  const variantIdEl = document.getElementById('pk-current-variant-id');
  const addBtn = document.getElementById('pk-add-to-cart');
  const realSubmit = document.getElementById('pk-real-submit'); // optional (if you use proxy button pattern)
  const optRadios = Array.from(document.querySelectorAll('.pk-option'));

  // ---------- Embroidery logic ----------
  const embroideryWrap = document.getElementById('pk-embroidery-text-wrap');
  const embroideryInput = document.getElementById('pk-embroidery-text');
  const rawOnValue = (document.getElementById('pk-embroidery-on-value')?.value || 'Avec prénom');
  const rawOptionName = (document.getElementById('pk-embroidery-option-name')?.value || 'Personnalisation');
  const norm = (s) => String(s || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').trim().toLowerCase();
  const embroideryOnValue = norm(rawOnValue);
  const embroideryOptionName = norm(rawOptionName);

  const currency = document.getElementById('pk-currency')?.value || 'EUR';

  // ---------- Product data ----------
  const variants = JSON.parse(document.getElementById('pk-variant-json')?.textContent || '[]');
  const productData = JSON.parse(document.getElementById('pk-product-json')?.textContent || '{"options":[],"selected":[]}');
  const optionNames = (productData.options || []).map((s) => norm(s));
  let selected = (productData.selected || []).slice();

  // ---------- Variant -> image map (from Liquid) ----------
  const imageMap = (() => {
    try { return JSON.parse(document.getElementById('pk-variant-image-map')?.textContent || '[]'); }
    catch { return []; }
  })();

  // ---------- Preload all variant images ----------
  const preloaded = new Set();
  function preloadAllVariantImages() {
    imageMap.forEach((entry) => {
      if (!entry || !entry.url || preloaded.has(entry.url)) return;
      const img = new Image();
      if (entry.srcset) img.srcset = entry.srcset;
      img.src = entry.url;
      preloaded.add(entry.url);
    });
  }
  preloadAllVariantImages();

  // ---------- Variant resolution ----------
  function findVariantByOptions(opts) {
    return variants.find((v) => v && v.options && v.options.every((val, i) => val === opts[i])) || null;
  }

  function formatMoney(cents) {
    const amount = (cents || 0) / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount); }
    catch { return amount.toFixed(2); }
  }

  // ---------- Embroidery visibility ----------
  function isEmbroideryOn() {
    const radios = Array.from(document.querySelectorAll('.pk-option[data-option-name]'))
      .filter((r) => norm(r.getAttribute('data-option-name')) === embroideryOptionName);
    const checked = radios.find((r) => r.checked);
    if (checked) return norm(checked.value) === embroideryOnValue;

    const idx = optionNames.indexOf(embroideryOptionName);
    if (idx === -1) return false;
    return norm(selected[idx]) === embroideryOnValue;
  }
  function showEmbroideryField(on) {
    if (!embroideryWrap) return;
    if (on) {
      embroideryWrap.hidden = false;
      embroideryInput?.setAttribute('required', 'required');
    } else {
      embroideryWrap.hidden = true;
      if (embroideryInput) {
        embroideryInput.value = '';
        embroideryInput.removeAttribute('required');
      }
    }
  }
  function refreshEmbroideryUI() { showEmbroideryField(isEmbroideryOn()); }

  // ===============================
  //   DOUBLE-BUFFER, NO-BLINK GALLERY
  // ===============================
  const serverImg = document.getElementById('pk-main-img'); // initially rendered in Liquid
  const mainWrap = serverImg?.closest('.pk-main-image');
  let layerA, layerB, activeLayer;

  // Ensure container keeps height (absolute children don't)
  if (mainWrap && serverImg) {
    const w = parseInt(serverImg.getAttribute('width') || '0', 10);
    const h = parseInt(serverImg.getAttribute('height') || '0', 10);
    if (w > 0 && h > 0) {
      mainWrap.style.aspectRatio = `${w} / ${h}`;
    } else {
      mainWrap.style.minHeight = '300px';
    }
  }

  if (mainWrap && serverImg) {
    // Create two stacked hero layers
    layerA = document.createElement('img');
    layerB = document.createElement('img');

    [layerA, layerB].forEach((el) => {
      el.className = 'pk-hero';
      el.setAttribute('decoding', 'async');
      el.setAttribute('sizes', '(max-width: 980px) 100vw, 50vw');
      el.setAttribute('fetchpriority', 'high');
      el.style.position = 'absolute';
      el.style.inset = '0';
      el.style.width = '100%';
      el.style.height = '100%';
      el.style.objectFit = 'cover';
      el.style.opacity = '0';
      el.style.transition = 'opacity .18s ease';
      mainWrap.appendChild(el);
    });

    // Seed layerA from the server image, then remove it
    layerA.src = serverImg.currentSrc || serverImg.src;
    if (serverImg.srcset) layerA.srcset = serverImg.srcset;
    layerA.alt = serverImg.alt || '';
    layerA.style.opacity = '1';
    activeLayer = layerA;

    serverImg.remove();
  }

  function buildVariantImageEntry(variant) {
    const entry = imageMap.find((x) => String(x.id) === String(variant.id));
    if (entry && entry.url) {
      return { url: entry.url, srcset: entry.srcset || '', alt: entry.alt || '' };
    }
    if (variant.featured_image && variant.featured_image.src) {
      const base = variant.featured_image.src.split('?')[0];
      return {
        url: `${base}?width=1200`,
        srcset: `${base}?width=480 480w, ${base}?width=768 768w, ${base}?width=1200 1200w`,
        alt: variant.featured_image.alt || ''
      };
    }
    return null;
  }

  function setMainImageForVariant(variant) {
    if (!mainWrap || !variant || !layerA || !layerB) return;
    const nextEntry = buildVariantImageEntry(variant);
    if (!nextEntry) return;

    const inactive = activeLayer === layerA ? layerB : layerA;

    // If already showing this URL, bail
    if (activeLayer && (activeLayer.currentSrc === nextEntry.url || activeLayer.src === nextEntry.url)) return;

    // Preload on inactive layer, then crossfade
    inactive.alt = nextEntry.alt || '';
    if (nextEntry.srcset) inactive.srcset = nextEntry.srcset; else inactive.removeAttribute('srcset');
    inactive.src = nextEntry.url;

    const reveal = () => {
      requestAnimationFrame(() => {
        if (activeLayer) activeLayer.style.opacity = '0';
        inactive.style.opacity = '1';
        activeLayer = inactive;
      });
    };

    if ('decode' in inactive && typeof inactive.decode === 'function') {
      inactive.decode().then(reveal).catch(reveal);
    } else if (inactive.complete) {
      reveal();
    } else {
      inactive.onload = reveal;
      inactive.onerror = reveal;
    }
  }

  // ---------- Apply variant to UI ----------
  function applyVariant(variant) {
    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (priceEl) priceEl.textContent = '—';
      return;
    }
    if (variantIdEl) variantIdEl.value = variant.id;
    if (addBtn) addBtn.disabled = !variant.available;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    setMainImageForVariant(variant);
  }

  // ---------- Init ----------
  applyVariant(findVariantByOptions(selected));
  refreshEmbroideryUI();

  // Mark active pills on load
  optRadios.forEach((r) => { if (r.checked) r.closest('.pk-pill')?.classList.add('is-active'); });

  // Option changes
  optRadios.forEach((r) => {
    r.addEventListener('change', () => {
      const idx = parseInt(r.getAttribute('data-option-index'), 10);
      selected[idx] = r.value;

      // pill visuals
      const groupName = r.getAttribute('name');
      document.querySelectorAll(`input[name="${groupName}"]`).forEach((el) => el.closest('.pk-pill')?.classList.remove('is-active'));
      r.closest('.pk-pill')?.classList.add('is-active');

      const v = findVariantByOptions(selected);
      applyVariant(v);
      refreshEmbroideryUI();
    });
  });

  // ---------- Quantity +/- ----------
  const qtyBox = document.querySelector('.pk-qty-box');
  function updateMinusState() {
    const input = document.querySelector('.pk-input--qty');
    const minus = document.querySelector('.pk-qty-btn[data-delta="-1"]');
    if (!input || !minus) return;
    const min = parseInt(input.getAttribute('min') || '1', 10);
    minus.disabled = parseInt(input.value || '1', 10) <= min;
  }
  if (qtyBox) {
    qtyBox.addEventListener('click', (e) => {
      const btn = e.target.closest('.pk-qty-btn');
      if (!btn) return;
      const input = qtyBox.querySelector('.pk-input--qty');
      const delta = parseInt(btn.dataset.delta, 10) || 0;
      const current = parseInt(input.value || '1', 10);
      const min = parseInt(input.getAttribute('min') || '1', 10);
      const step = parseInt(input.getAttribute('step') || '1', 10);
      const next = Math.max(min, current + delta * step);
      input.value = next;
      updateMinusState();
    });
    qtyBox.querySelector('.pk-input--qty')?.addEventListener('input', updateMinusState);
    updateMinusState();
  }

  // ---------- Harden add-to-cart (bypass app hijacks) ----------
  function collectProperties() {
    const props = {};
    form.querySelectorAll('input[name^="properties["]').forEach((el) => {
      const name = el.name.match(/^properties\[(.+)\]$/)?.[1];
      if (!name) return;
      if ((el.type === 'radio' && el.checked) || el.type !== 'radio') {
        const v = (el.value || '').trim();
        if (v) props[name] = v;
      }
    });
    return props;
  }

  form.addEventListener('submit', async (e) => {
    // Take control: prevent app/theme submit handlers from swapping the product
    e.preventDefault();
    e.stopImmediatePropagation();

    // Validate embroidery when on
    if (isEmbroideryOn()) {
      const maxLen = parseInt(embroideryInput?.getAttribute('maxlength') || '20', 10);
      const val = (embroideryInput?.value || '').trim();
      const ok = /^[-'\p{L}\p{N} ]{0,40}$/u.test(val) && val.length <= maxLen;
      if (!ok) { embroideryInput?.reportValidity(); return; }
    } else if (embroideryInput) {
      embroideryInput.value = '';
    }

    const id = parseInt(variantIdEl?.value || '0', 10);
    const qty = parseInt(document.getElementById('pk-qty')?.value || '1', 10) || 1;
    if (!id) { console.warn('[PK] No variant id'); return; }

    if (addBtn) addBtn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity: qty, properties: collectProperties() })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        alert(err?.description || 'Impossible d’ajouter cet article.');
        return;
      }
      // Success: open cart or redirect (choose one)
      document.dispatchEvent(new CustomEvent('pk:added', { detail: { id, qty } }));
      // If you have a cart drawer, trigger it here; else redirect:
      window.location.href = '/cart';
    } finally {
      if (addBtn) addBtn.disabled = false;
    }
  }, true); // capture phase to beat other listeners

  // If using a proxy CTA (visible type="button"): click -> submit
  if (addBtn && addBtn.type === 'button') {
    addBtn.addEventListener('click', () => {
      if (addBtn.disabled) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(realSubmit || undefined);
      else if (realSubmit) realSubmit.click();
      else form.submit(); // will be intercepted by our submit handler above
    });
  }
})();
